import React, { useState, useEffect } from 'react';

import { LinkAnchor } from '../../Links';
import { getEventRedirectUrl, getUseAnchorForEventLink, isTmsTeamMatchEvent, isAdultTeamTennisMatch } from '../../../utils/events';
import BackgroundImage from '../../BackgroundImage';
import PopOverMenu from '../../PopOverMenu';

const TeamEventCard = (props) => {
    const {
        force,
        forceCardView,
        auth,
        event,
        showAdminOptions,
        isCollege,
        onTeamMatchMenuSelected,
        'data-testid': dataTestId,
    } = props;

    const {
        id,
        published,
        matchDate,
        matchDateTimeShort,
        matchLocationShort,
        team1,
        team2,
        scoreTeam1,
        scoreTeam2,
        source,
        inFuture,
        isConference,
        eventTypeId,
    } = event;
    const [menuOptions, setMenuOptions] = useState([]);

    console.log('team1', team1);
    console.log('team2', team2);

    const allowUserToPerFormAction = isCollege && isTmsTeamMatchEvent(source) && showAdminOptions;
    const showDraftForCollegeCoach = allowUserToPerFormAction ? showAdminOptions : true;

    useEffect(() => {
        if (showAdminOptions && (isTmsTeamMatchEvent(source) || isAdultTeamTennisMatch(eventTypeId))) {
            setMenuOptions(allowUserToPerFormAction
                ? [{
                    id: 'edit',
                    label: 'Edit Match',
                    value: 'edit',
                }]
                : [
                    {
                        id: 'include_in_standings',
                        label: 'Include Match In Team Standings',
                        value: 'include_in_standings',
                        show: !isConference,
                    },
                    {
                        id: 'omit_from_standings',
                        label: 'Omit Match From Team Standings',
                        value: 'omit_from_standings',
                        show: isConference,
                    },
                    {
                        id: 'edit',
                        label: 'Edit Match',
                        value: 'edit',
                    },
                ]);
        } else {
            setMenuOptions([]);
        }
    }, [showAdminOptions, isConference]);

    const isPoweredUser = auth && auth.user && auth.user.isPoweredUser;
    const showMenuoptions = menuOptions && menuOptions.length > 0;

    const onMenuSelected = (menuOption) => {
        onTeamMatchMenuSelected(menuOption, id);
    };

    const getCardTeam = (team, teamScore, oppScore) => {
        return (
            <div className={`team ${teamScore < oppScore ? 'loser' : ''}`}>
                <div className="flex-column club-details-container">
                    <div className="club-details">
                        <BackgroundImage
                            baseUrl={'/v1/club/'}
                            defaultImage={'/img/v2/icons/icon-avatar-team.svg'}
                            images={team.clubProfileImages}
                            imageType={'thumbnail'}
                            parentStylesClass={'club-profile-image'}
                        />
                        <div
                            className={`team-name`}
                        >
                            <span
                                className="name-wrapper"
                                data-testid={dataTestId && `${dataTestId}.card.team-${team.id}.name`}
                            >
                                {team.shortName}
                            </span>
                            {isPoweredUser && team.power6 && (
                                <div className="power6 text-gray" data-testid={dataTestId && `${dataTestId}.card.team-${team.id}.power6`}>
                                    {`${team.power6} Power 6`}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div className="flex-column scores-conatiner" data-testid={dataTestId && `${dataTestId}.card.team-${team.id}.score`}>
                    {teamScore}
                </div>
                <div className="flex-column winner-display-conatiner">
                    {teamScore > oppScore && (
                        <div className="winning-scores" />
                    )}
                </div>
            </div>
        );
    };

    const getListTeam = (team, teamScore, oppScore) => {
        return (
            <div className={`team ${teamScore < oppScore ? 'loser' : ''}`}>
                <div className="flex-column club-details-container">
                    <div className="club-details">
                        <BackgroundImage
                            baseUrl={'/v1/club/'}
                            defaultImage={'/img/v2/icons/icon-avatar-team.svg'}
                            images={team.clubProfileImages}
                            imageType={'thumbnail'}
                            parentStylesClass={'club-profile-image'}
                        />
                        <div
                            className={`team-name`}
                        >
                            <span
                                className="name-wrapper"
                                data-testid={dataTestId && `${dataTestId}.desktop.team-${team.id}.name`}
                            >
                                {team.shortName}
                            </span>
                            {isPoweredUser && team.power6 && (
                                <div className="power6 text-gray" data-testid={dataTestId && `${dataTestId}.desktop.team-${team.id}.power6`}>
                                    {`${team.power6} Power 6`}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div className="flex-column scores-conatiner" data-testid={dataTestId && `${dataTestId}.desktop.team-${team.id}.score`}>
                    {teamScore}
                </div>
                <div className="flex-column winner-display-conatiner">
                    {teamScore > oppScore && (
                        <div className="winning-scores" />
                    )}
                </div>
            </div>
        );
    };

    const renderEvent = () => {
        return (
            <div className={`utr-card team-event-card`}>
                <div className={`${forceCardView || (force && force.cardView) ? 'd-none' : 'd-none d-md-block'}`}>
                    <div className={`list-view`}>
                        <div className="row">
                            <div className={`${showMenuoptions ? 'col-7' : 'col-8'}`}>
                                <div className="flex-1">
                                    {getListTeam(team1, scoreTeam1, scoreTeam2)}
                                    {getListTeam(team2, scoreTeam2, scoreTeam1)}
                                </div>
                            </div>
                            <div className="col-4 border-left">
                                <div className="d-flex flex-column mw0 w-100">
                                    {(!published && showDraftForCollegeCoach) && (
                                        <div className="ase pb8">
                                            <div className={`tag tag-gray tag-xs tag-block`}>Draft</div>
                                        </div>
                                    )}
                                    <div className="text-small text-gray show-ellipsis" data-testid={dataTestId && `${dataTestId}.desktop.date`}>
                                        {inFuture ? matchDateTimeShort : matchDate}
                                    </div>
                                    <div className="text-small text-gray show-ellipsis" data-testid={dataTestId && `${dataTestId}.desktop.location`}>
                                        {matchLocationShort}
                                    </div>
                                </div>
                            </div>
                            <div className={`${showMenuoptions ? 'col-1' : 'd-none'}`}>
                                {showMenuoptions && (
                                    <PopOverMenu
                                        horizontalEllipsis={false}
                                        popOverMenuClass="mt4 popover-ellipsis"
                                        menuItems={menuOptions}
                                        onSelected={onMenuSelected}
                                        data-testid={dataTestId && `${dataTestId}.desktop.menu`}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`${forceCardView || (force && force.cardView) ? 'd-block' : 'd-block d-md-none'}`}>
                    <div
                        className={`card-view`}
                    >
                        <div className="header">
                            <div className="d-flex mb16 mr24">
                                <div className="flex-1" data-testid={dataTestId && `${dataTestId}.mobile.date`}>{inFuture ? matchDateTimeShort : matchDate}</div>
                                {showMenuoptions && (
                                    <PopOverMenu
                                        horizontalEllipsis={false}
                                        popOverMenuClass="mt4 popover-ellipsis"
                                        menuItems={menuOptions}
                                        onSelected={onMenuSelected}
                                        data-testid={dataTestId && `${dataTestId}.mobile.menu`}
                                    />
                                )}
                            </div>
                            <div>
                                {getCardTeam(team1, scoreTeam1, scoreTeam2)}
                                {getCardTeam(team2, scoreTeam2, scoreTeam1)}
                            </div>
                        </div>
                        <hr className="mb0 mt0 ml24 mr24" />
                        <div className="footer">
                            <div data-testid={dataTestId && `${dataTestId}.mobile.location`}>
                                {matchLocationShort}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <>
            <LinkAnchor
                link={getEventRedirectUrl(id, source)}
                useAnchor={getUseAnchorForEventLink(source)}
                target={'_self'}
                data-testid={dataTestId && `${dataTestId}.card-link`}
            >
                {renderEvent()}
            </LinkAnchor>
        </>
    );
};

TeamEventCard.defaultProps = {
    'data-testid': null,
};

export default TeamEventCard;
